export default __webpack_public_path__ + "static/media/milestone 850.b5274941.svg";